import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AprobacionCliente } from './aprobacionCliente.model';
import { Cliente } from '../../cliente/cliente.model';
import { BackendService } from '../../core/backend.service';
import { ValidarDocumentacion } from './validarDocumentacion.model';
import { SnackService } from '../../shared-services/snack.service';

@Injectable()
export class AprobacionClienteResolver implements Resolve<ValidarDocumentacion> {
  constructor(
    protected router: Router,
    protected backendService: BackendService,
    private snackService: SnackService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const id = route.params.id;
      const cliente = await this.backendService.get(Cliente, Cliente.path + id).toPromise();
      const validacion = await this.backendService.get(AprobacionCliente, Cliente.path + AprobacionCliente.path + id).toPromise();
      return {cliente: cliente, validacion: validacion};
    } catch (ex) {
      if (ex[0]) {
        this.snackService.error(ex[0].details);
      } else if (ex.errors) {
        this.snackService.error(ex.errors[0].defaultMessage);
      } else {
        this.snackService.error(ex.message);
      }
      this.router.navigate(['/clientes']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/validar-documentacion/aprobacionCliente.resolver.ts